import { render, staticRenderFns } from "./UserSort.vue?vue&type=template&id=61f4aca9&scoped=true&"
import script from "./UserSort.vue?vue&type=script&lang=js&"
export * from "./UserSort.vue?vue&type=script&lang=js&"
import style0 from "./UserSort.vue?vue&type=style&index=0&id=61f4aca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4aca9",
  null
  
)

export default component.exports